import React, { useEffect, useState } from "react";

function fmt(s) {
  if (s == null || s < 0) return "00:00:00";
  const h = String(Math.floor(s / 3600)).padStart(2, "0");
  const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
  const sec = String(Math.floor(s % 60)).padStart(2, "0");
  return `${h}:${m}:${sec}`;
}

export function BuildTimer({ startTime, endTime, running, size = "md" }) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!startTime) {
      setSeconds(0);
      return;
    }
    const start = new Date(startTime).getTime();
    const compute = () => {
      const end = endTime ? new Date(endTime).getTime() : Date.now();
      setSeconds(Math.max(0, Math.floor((end - start) / 1000)));
    };
    compute();
    if (!running) return;
    const id = setInterval(compute, 1000);
    return () => clearInterval(id);
  }, [startTime, endTime, running]);

  const cls = size === "xl" ? "text-6xl md:text-7xl" : size === "lg" ? "text-4xl md:text-5xl" : "text-2xl";

  return (
    <span className={`font-mono font-light ${cls} text-white`} data-testid="build-timer">
      {fmt(seconds)}
    </span>
  );
}
